import { DocumentCategory } from '../types';

export const DOCUMENT_CATEGORIES: DocumentCategory[] = [
  'bulletin-de-paie',
  'dsn',
  'contrat',
  'attestation',
  'facture',
  'document-rh',
  'reglementaire',
  'identifiant',
  'document-texte',
  'autre',
];

export const CATEGORY_ICONS: Record<DocumentCategory, string> = {
  'bulletin-de-paie': '🧾',
  'dsn': '📋',
  'contrat': '📝',
  'attestation': '🎫',
  'facture': '💰',
  'document-rh': '👥',
  'reglementaire': '⚖️',
  'identifiant': '🔐',
  'document-texte': '📄',
  'autre': '📎',
};

